"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const typography_1 = require("../styles/typography");
const Tab = ({ val, selected, onClick, tabStyle }) => {
    const container = Object.assign({}, typography_1.text, typography_1.medium, { height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: selected === val ? typography_1.regular.fontWeight : typography_1.semibold.fontWeight, color: selected === val ? colors_1.black : colors_1.turquoise, position: 'relative' }, tabStyle.container);
    const selectedStyle = Object.assign({ position: 'absolute', bottom: 0, left: 0, width: '100%', height: 2, background: colors_1.turquoise }, tabStyle.selection);
    const onTabClick = () => {
        const contentEditableText = document.getElementById('contentEditableText');
        if (contentEditableText && contentEditableText.children[1] === document.activeElement) {
            ;
            contentEditableText.children[1].blur();
        }
        onClick(val);
    };
    const unselectedStyle = Object.assign({}, selectedStyle, { background: colors_1.titanium, height: 1 });
    return (React.createElement("div", { style: container, onClick: () => onTabClick() },
        val,
        React.createElement("div", { style: selected === val ? selectedStyle : unselectedStyle })));
};
Tab.defaultProps = {
    tabStyle: {
        container: {},
        selection: {},
    },
};
exports.default = Tab;
